import React, { lazy, Suspense } from 'react';
import { Nav, Navbar, NavDropdown, Button, Container } from 'react-bootstrap';
import AppConstants from '../../core-components/AppConstants';
import styles from './LoginHeader.module.scss';
const Image = lazy(() => import('../../core-components/Image'));

const LoginHeader = () => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <div className={styles.svNavbar}>
        <Navbar expand='xl' sticky='top' className={styles.navbar}>
          <Navbar.Brand href='/' className={styles.navbar_brand}>
            <Image name='logo.svg' />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls='basic-navbar-nav' />
          <Navbar.Collapse id='basic-navbar-nav' className={styles.navbar_show}>
            <Container className={styles.container}>
              <Nav className={styles.navbar_nav}>
                <NavDropdown
                  className={styles.basic_nav_dropdown}
                  title={
                    <>
                      <Image name='india_flag.png' />
                      <span>{'SpringVerify India'}</span>
                    </>
                  }
                  id='basic-nav-dropdown'
                >
                  <NavDropdown.Item href={'/'}>
                    <Image name='india_flag.png' />
                    {'SpringVerify India'}
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    onClick={() => window.open(`${AppConstants.sv_us_URL}`)}
                    target={'_blank'}
                  >
                    <Image name='us_flag.png' />
                    {'SpringVerify USA'}
                  </NavDropdown.Item>
                </NavDropdown>

                <Nav.Link href='/'>Home</Nav.Link>
                <Nav.Link href='https://whatsapp.springverify.com/' target={'_blank'}>
                  Verify on Whatsapp
                </Nav.Link>
                <Nav.Link href='/login'>Sign In</Nav.Link>
                <Button
                  className={styles.getStartedBtn}
                  onClick={() => window.open(`${AppConstants.phpURL}#footer`, '_self')}
                >
                  Get Started
                </Button>
              </Nav>
            </Container>
          </Navbar.Collapse>
        </Navbar>
      </div>
    </Suspense>
  );
};

export default React.memo(LoginHeader);
